export default __webpack_public_path__ + "assets/micronesia-flag.png";